import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IMenuItem } from '../../../core/services/navigation.service';

@Injectable({ providedIn: 'root' })
export class SidenavOverflowService {
  private state$ = new BehaviorSubject<{ visible: IMenuItem[]; overflow: IMenuItem[] } | null>(null);
  readonly overflow$ = this.state$.asObservable();

  set(visible: IMenuItem[], overflow: IMenuItem[]): void {
    this.state$.next({ visible, overflow });
  }
}
